import LogDataMessageModel from "@/common/models/Logs/LogDataMessageModel";

export default class LogMessageModel {

    nextPageToken: string| undefined;
    entries : Array<LogDataMessageModel>  = [];
}